<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogCategoryTree"
      persistent
      scrollable
      max-width="450px"
    >
      <v-card class="treeViewCat">
        <v-card-title>
          <span class="headline">{{$t('dialog.SelectCategory')}}</span>
        </v-card-title>
        <v-card-text>
          <template>
            <template>
              <v-treeview
                v-if="categories != ''"
                v-model="selectionCategory"
                class=""
                open-on-click
                rounded
                hoverable
                selectable
                :items="categories"
                item-key="categoryid"
                return-object
              >
                <template v-slot:prepend="{ item }">
                  <template>
                    <div class="radioBTN" v-if="item.categoryname != undefined">
                      {{ item.translate.categorynametrans[lang] }}
                    </div>
                  </template>
                </template>
              </v-treeview>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeCateDialog()">
            {{$t('public.close')}}
          </v-btn>
          <v-btn color="green darken-1" text @click="sendCategories()">
            {{$t('public.select')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style >
.treeviewClass .v-input--selection-controls__ripple {
  height: 22px;
  width: 22px;
}
.radioBTN .v-icon.v-icon {
  font-size: 18px;
  top: 2px;
}

.treeviewClass .v-input--selection-controls__ripple {
  left: -6px;
  top: calc(50% - 16px);
}
.treeviewClass
  .v-treeview-node.v-treeview-node--rounded
  .v-treeview-node__root {
  height: 20px;
  margin: 0;
}
.treeviewClass .v-input--selection-controls {
  padding: 0;
}
.treeviewClass .v-input--selection-controls__input {
  margin-right: 2px;
  margin-left: -5px;
}
.treeviewClass .v-treeview-node {
  margin: -5px 0;
}
.treeViewCat .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root {
  margin-top: 0 !important ;
  margin-bottom: 0 !important ;
}
.treeViewCat .v-treeview-node__root{
  min-height: 35px;
}
</style>

<script>
export default {
  props: ["dialogCategoryTree", "selectedCategories"],
  data() {
    return {
      categories: [],
      selectionCategory: [],
      radioGroup: null,
      SelectedCategory: {
        ID: "",
        Name: "",
      },
    };
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
  },

  mounted() {
    this.getTreeItems();
    this.selectionCategory = this.selectedCategories;
  },

  methods: {
    getTreeItems() {
      this.$store
        .dispatch("GetFromAPI", "/guest/categorytree")
        .then((response) => {
          this.categories = response["data"]["data"];
        });
    },
    sendCategories() {
      if (this.selectionCategory == null) {
        this.$store.dispatch("PushErrorMsg", this.$t('public.DataNotValid'));
        return false;
      }
      this.$emit("closeCatDialogWithCategories", this.selectionCategory);
    },
    closeCateDialog() {
      this.$emit("closeCatDialog", false);
    },
  },
};
</script>
